<template>
  <div class="weeks">
    <span id="w-add-up">
      <WeeksGroupAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <span id="w-send">
    </span>
    <va-card :title="$t('weeks-group.cards.title')">
      <template slot="actions">
        <va-button
          @click="open"
          href='#w-add-up'
          icon="fa fa-plus"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="week_groups"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover
            :message="`${$t('weeks-group.tooltips.rankinS1')}`"
            placement="bottom"
          >
            <va-button
              flat
              color="gray"
              icon="fa fa-star"
              :to="{
                name: 'week-groups-ranking-s1',
                params: { group: props.rowData.id }
              }"
            />
          </va-popover>
          <va-popover
            :message="`${$t('weeks-group.tooltips.rankinGroup')}`"
            placement="bottom"
          >
            <va-button
              flat
              color="gray"
              icon="fa fa-signal"
              :to="{
                name: 'week-groups-ranking',
                params: { group: props.rowData.id }
              }"
            />
          </va-popover>
          <va-popover :message="`${$t('weeks-group.tooltips.weeks')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-calendar"
              :to="{ name: 'weeks', params: { weekGroup: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('weeks-group.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href='#w-add-up'
              @click="update(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import WeeksGroupAddUpdate from './WeeksGroupAddUpdate.vue'

const perPage = 10
export default {
  name: 'weeksGroup',
  components: { WeeksGroupAddUpdate },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.week_groups.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
  },
  data () {
    return {
      week_groups: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      titleCard: '',
      updateData: null,
      userId: null,
    }
  },
  apollo: {
    week_groups: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2) {
        week_groups: week_group(limit: $perPage, offset: $page, order_by: {id: desc}) {
          id
          name
          active
        }
      }
      `,
      variables: {
        perPage,
        page: 0,
      },
    },
    pages: gql`
    query MyQuery {
      pages: week_group_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'name',
        title: this.$t('weeks-group.headings.group'),
        width: '50%',
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
        titleClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('week_groups')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.week_groups.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
